<template>
  <b-modal
    id="processing-modal"
    :hide-footer="!showCancel"
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    :modal-class="isV2 ? 'modal-v2-wrapper' : 'success-popup success-popup_wrong'"
    no-fade
  >
    <div
      v-if="isV2"
      class="modal-v2-content"
    >
      <!-- Icon -->
      <div class="modal-v2-icon processing">
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
          />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      </div>
      <!-- Title -->
      <h2 class="modal-v2-title">
        {{ modalTitle }}
      </h2>
      <!-- Message -->
      <p class="modal-v2-message">
        Please wait...
      </p>
    </div>
    <div
      v-else
      class="text-center modal-complete"
    >
      <svg class="icon icon-icon-popup-wrong">
        <use xlink:href="#icon-icon-popup-wrong" />
      </svg>

      <h2>
        {{ modalTitle }}
      </h2>

      <div class="popup-meta" />

      <div class="d-flex justify-content-center align-items-center" />
    </div>
    <template
      v-if="showCancel"
      #modal-footer
    >
      <div class="d-flex justify-content-center w-100">
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: "ProcessingModal",
    props:{
      modalTitle:{
        type:String,
        default:"Processing 1"
      },
      v2: {
        type: Boolean,
        default: false
      },
      showCancel: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isV2() {
        // Auto-detect if in Kiosk V2 or use v2 prop
        return this.v2 || this.$route?.name?.includes('V2') || false;
      }
    }
  }
</script>

<style scoped>

</style>
